import React from 'react';
import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { StyledDialogTitle } from '../styled/Dialog/StyledDialogTitle';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import StyledTitle from '../styled/Dialog/StyledTitle';
import useAddToCompanyDialog from '../../hooks/useAddToCompanyDialog';
import { AddToCompanyForm } from '../admin/users/AddToCompanyForm';

const AddToCompanyDialog: React.FC<{ open: boolean }> = (props) => {
    const addToCompanyDialog = useAddToCompanyDialog();
    const { t } = useTranslation('admin', {
        keyPrefix: 'ADD_TO_COMPANY',
    });
    const company = addToCompanyDialog.addToCompanyDialogState.company;
    const handleClose = () => {
        addToCompanyDialog.closeDialog();
    };

    const handleSuccess = () => {
        addToCompanyDialog.closeWithSuccessDialog();
    };

    return (
        <Dialog
            open={props.open}
            onClose={handleClose}
            maxWidth={'sm'}
            fullWidth
        >
            <StyledDialogTitle>
                <StyledTitle>{t('TITLE')}: {company.name}</StyledTitle>
                <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
            </StyledDialogTitle>
            <StyledDialogContent>
                <AddToCompanyForm submitSuccess={handleSuccess} />
            </StyledDialogContent>
        </Dialog>
    );
};

export default AddToCompanyDialog;
